import React from "react";

export default function PopupPass() {
    
  return (
<div id = 'helper2'>
    <div className = 'alertContainer'>
    <div id="popUpOverlay">
      <div id="popUpBox">
      <p className = 'popUpText'>
        Password has been successfully updated.
      </p>
      <button className = 'alert_button' onClick={()=>removeComp()}
      > 
      OK
      </button>
      </div>
    </div>
    </div>
    </div>
  );
  
}
function removeComp(){
    document.getElementById('helper2').style.display = 'none';
}